export default __webpack_public_path__ + "static/media/electricstation.3f686ad9.svg";